import { render } from "./addphone.vue?vue&type=template&id=557207d2&scoped=true"
import script from "./addphone.vue?vue&type=script&lang=js"
export * from "./addphone.vue?vue&type=script&lang=js"

import "./addphone.vue?vue&type=style&index=0&id=557207d2&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557207d2"]])

export default __exports__